/**
 * TS types that should be auto-generated
 */

export interface MonthYear {
  month: number | null;
  year: number;
}

export enum OrderType {
  HOURLY = 'HOURLY',
  PACKAGE = 'PACKAGE',
  CLASS = 'CLASS',
  BOOTCAMP = 'BOOTCAMP',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export enum PaymentStructure {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
}

export enum PostSessionReviewType {
  COACH = 'coach',
  BOOTCAMP = 'bootcamp',
  BOOTCAMP_SESSION = 'bootcamp_session',
}
